import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Button, Modal, Tabs } from 'antd';
import PropTypes from 'prop-types';
import { getConfigurationMessages, getFields, getModalMessages, getTopMenuMessages } from '../constants/messages';
import { isTablet } from '../utilities/util';
import GeneralConfig from './GeneralConfig';

let fieldsMessages = getFields(),
	configurationMessages = getConfigurationMessages(),
	modalMessages = getModalMessages(),
	menuMessages = getTopMenuMessages();

const messages = {
	...modalMessages,
	...menuMessages,
	...fieldsMessages,
	...configurationMessages,
};

const Configuration = ({ intl, showModal, handleCancel }) => {
	const items = [
		{
			key: '1',
			label: intl.formatMessage({ ...messages.general }),
			children: <GeneralConfig />,
		},
	];

	return (
		<Modal
			open={showModal}
			title={intl.formatMessage({ ...messages.config })}
			onCancel={handleCancel}
			destroyOnClose={true}
			footer={[
				<Button key="close" size="large" onClick={handleCancel}>
					<FormattedMessage {...messages.close} />
				</Button>,
			]}
		>
			<Tabs
				defaultActiveKey="1"
				items={items}
				tabPosition={isTablet() ? 'top' : 'left'}
				className="profileModal"
			/>
		</Modal>
	);
};

Configuration.propTypes = {
	intl: PropTypes.object.isRequired,
	showModal: PropTypes.bool.isRequired,
	handleCancel: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => {
	return {
		showModal: state.configuration.showConfiguration,
	};
};

export default connect(mapStateToProps)(injectIntl(Configuration));
